<template>
  <div id="app">
    <router-view/>
    <snackbar></snackbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Snackbar from '@/components/Snackbar';

export default {
  name: 'App',

  components: {
    Snackbar,
  },

  methods: {
    ...mapActions({
      setHeaders: 'drivers/setDeskRhHeaders',
    }),
  },

  created() {
    this.setHeaders();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue